import { environment } from './../../../../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../../../../../core/constantes/constantes.service';
import { Observable } from 'rxjs/Observable';
import { KPI } from './../../../../../core/modelos/kpi';

@Injectable()
export class KpisService {

    constructor(private http: HttpClient, private constantes: ConstantesService) { }

    getKpis(): Observable<any> {
        return this.http.get(environment.urlBase + 'kpis', this.constantes.httpOptions);
    }

    getKpi(id: number): Observable<any> {
        return this.http.get(environment.urlBase + 'kpis/' + id, this.constantes.httpOptions);
    }

    updateKpi(kpi: KPI): Observable<any> {
        return this.http.put(environment.urlBase + 'kpis/' + kpi.id, kpi, this.constantes.httpOptions);
    }

    addKpi(kpi: KPI): Observable<any> {
        return this.http.post<KPI>(environment.urlBase + 'kpis', kpi, this.constantes.httpOptions);
    }

    deleteKpi (id: number): Observable<any> {
        return this.http.delete(environment.urlBase + 'kpis/' + id, this.constantes.httpOptions);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/activos/components/kpis-tabla/kpis.service.ts